import { render, staticRenderFns } from "./ProductOrderFilters.vue?vue&type=template&id=f00b8b0e"
import script from "./ProductOrderFilters.vue?vue&type=script&lang=ts"
export * from "./ProductOrderFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports